<template>
  <v-container
    fluid
    fill-height
    class="ma-0 pa-0"
    @click="onFieldsClick"
    style="cursor: pointer"
  >
    <template v-for="(field, index) in fieldList">
      <v-row
        no-gutters
        class="my-1"
        v-bind:key="`document-item.field-${index}`"
        v-if="field.isVisible"
      >
        <v-col cols="4">
          <span class="ml-1">{{ field.title }}</span>
        </v-col>
        <v-col cols="8">
          <span>{{ field.value }}</span>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
export default {
  name: "DocumentItemFields",
  props: {
    documentId: {
      type: Number,
    },
    fieldList: {
      type: Array,
    },
  },
  methods: {
    onFieldsClick() {
      this.$emit("on-fields-click");
    },
  },
};
</script>
